import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Updates from './components/Updates';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Media from './components/Media';
import Topics from './components/Topics';
import IndexSection from './components/IndexSection';
import Carousel from './components/Carousel';
import Comments from './components/Comments';
import About from './components/About';
import Cards from './components/Cards';
import Ranking from './components/Ranking';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <Updates />
        <FAQ />
        <Contact />
        <Media />
        <Topics />
        <IndexSection />
        <Carousel />
        <Comments />
        <About />
        <Cards />
        <Ranking />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}